// `video.image`: animate an image (D3), to an end frame where the model takes one (#228).
// Live's video list label (`VIDEO_GENERATION_TYPE_LABEL`).
import { VideoImageQuote, VideoImageRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { assetRefOf, commonFields, elementsOf, everyShotWritten, videoFields } from "./shared";

export const jobType: JobTypeModule<"video.image"> = {
  type: "video.image",
  label: "Image-to-Video",
  source: "image",
  pair: "video.text",
  fields: (draft, advanced) => ({
    ...commonFields(draft),
    ...videoFields(draft, advanced),
    start_frame: draft.source,
    ...(draft.endFrame === null ? {} : { end_frame: draft.endFrame }),
    // Kling 4.0's keyframes between the frames, in order (spec web/keyframes-slot).
    ...(draft.middleFrames.length === 0
      ? {}
      : { middle_frames: draft.middleFrames.map((frame) => assetRefOf(frame)) }),
    ...elementsOf(draft),
  }),
  request: VideoImageRequest.refine(everyShotWritten),
  quote: VideoImageQuote,
};
